import { enableProdMode, inject, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { Angulartics2Module } from 'angulartics2';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { AuthService } from '@services/auth.service';
import { TokenInterceptor } from './app/core/interceptors/token.interceptor';
import { provideGoogleTagManager } from 'angular-google-tag-manager';
import { Overlay } from '@angular/cdk/overlay';
import { MAT_DIALOG_SCROLL_STRATEGY } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { routes } from './app/app.routing';

if (environment.production) enableProdMode();

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([TokenInterceptor])),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'top' })),
    provideOAuthClient(),
    provideAppInitializer(() => inject(AuthService).initAuthObs()),
    provideTranslateService({
      lang: 'fr',
      fallbackLang: 'fr',
      loader: provideTranslateHttpLoader({ useHttpBackend: true })
    }),
    provideGoogleTagManager({ id: environment.GTM_ID }),
    Angulartics2Module.forRoot().providers || [],
    DatePipe,
    {
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.noop(),
      deps: [Overlay]
    }
  ]
}).catch((err) => console.error(err));
